import './App.css';
import i18n from './i18n';
import Loader from 'react-loader-spinner'
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactGA from 'react-ga';
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, } from 'react-router-dom';
import { PrivateRoute } from './_components/PrivateRoute';
import { ErrorBoundary } from './ErrorBoundary';
import {getTheme, getButtonThemeColor} from './_common/GetTheme';
import videoPreLoader from './_common/VideoPreLoader';
// import { App as WidgetApp } from './webscan/containers/App/App'
// import ScanLogic from './webscan/containers/Core/ScanLogic'
// import { Tiltometer } from './webscan/components/Tiltometer'
// import { Volume } from './webscan/components/Volume'


// import { SizerScanComponent } from './Vendors/Sizer';

const Tiltometer = lazy(() => import('./webscan/components/Tiltometer'))
const Volume = lazy(() => import('./webscan/components/Volume'))
const ScanLogic = lazy(() => import('./webscan/containers/Core/ScanLogic'))
const WidgetApp = lazy(() => import('./webscan/containers/App/App'))
const SizerScanComponent = lazy(() => import('./Vendors/Sizer/SizerScanComponent'))
const BarrierScanComponent = lazy(() => import('./Vendors/Barrier/BarrierScanComponent'))

class App extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      themeName: 'pcami'
    }
    let public_url = process.env.PUBLIC_URL;
    let baseUrl = public_url + '/assets/videos/sizer/tutorial/';
    videoPreLoader([baseUrl + 'tutorial_tight.mp4',
                    baseUrl + 'tutorial_placement.mp4',
                    baseUrl + 'tutorial_distance.mp4'
    ]);
  }

  componentDidMount() {
    const urlQuery = new URLSearchParams(document.location.search)
    this.setState({ themeName: getTheme()});
    // temporary fix - incase of spanish theme - force spanish
    // if(this.state.themeName == 'pcami'){
    //   i18n.changeLanguage('es');
    //   window.location='sizer://setoption?lang=es';
    // }

    ReactGA.initialize('UA-209501770-1');
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  render() {
    let dotColor = getButtonThemeColor();
    return (
      <ErrorBoundary>
        <div className={this.state.themeName}>
          <div className="col-sm-offset-2">
            <Router>
              <Suspense fallback={
                  <div className='waitHolder'>
                  <Loader
                      type="ThreeDots"
                      color={dotColor}
                      height={60}
                      width={60}
                  />
                </div>
              }>
              <PrivateRoute exact path="/" component={SizerScanComponent} />
              {/* <PrivateRoute exact path="/" component={WidgetApp} /> */}
              <PrivateRoute exact path="/tilt" component={Tiltometer} />
              <PrivateRoute exact path="/volume" component={Volume} />
              <PrivateRoute exact path="/scan" component={ScanLogic} />
              <PrivateRoute exact path="/widget" component={WidgetApp} />
              <PrivateRoute exact path="/vendor/sizer" component={SizerScanComponent} />
              <PrivateRoute exact path="/vendor/barrier" component={BarrierScanComponent} />
            </Suspense>
            </Router>
          </div>
        </div>
      </ErrorBoundary>
    );
  }
}

export default App;

/*
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          <div className='card'>
            aaa
          </div>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
*/